import { DataValidationError } from "constants/DataValidationError";
import { IsAscii, IsEmail, IsNotEmpty, MaxLength } from "class-validator";
import Spec from "constants/Spec";

export default class LoginCastReq {
  @MaxLength(Spec.maxLength.cast.email, {
    message: DataValidationError.DATA_IS_TOO_LONG,
    context: {
      constraint1: Spec.maxLength.cast.email,
    },
  })
  @IsNotEmpty({ message: DataValidationError.DATA_IS_EMPTY })
  @IsEmail(
    {},
    {
      message: DataValidationError.DATA_IS_INVALID,
    }
  )
  email!: string;

  @IsNotEmpty({
    message: DataValidationError.DATA_IS_EMPTY,
  })
  @MaxLength(Spec.maxLength.cast.password, {
    message: DataValidationError.DATA_IS_TOO_LONG,
    context: {
      constraint1: Spec.maxLength.cast.password,
    },
  })
  @IsAscii({
    message: DataValidationError.DATA_IS_INVALID,
  })
  password!: string;

  constructor(arg: any) {
    arg = arg || {};
    this.email = arg.email;
    this.password = arg.password;
  }
}
